module.exports = __webpack_public_path__ + "static/media/marca.91f10e00.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/MarkCall/marca.svg
// module id = 1807
// module chunks = 0